import { render, staticRenderFns } from "./ListServicesGeneral.vue?vue&type=template&id=593867ea"
import script from "./ListServicesGeneral.vue?vue&type=script&lang=js"
export * from "./ListServicesGeneral.vue?vue&type=script&lang=js"
import style0 from "./ListServicesGeneral.vue?vue&type=style&index=0&id=593867ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports